module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "1050"
    },
    model: {
      value: (_vm.dialogUploadLiveClass),
      callback: function($$v) {
        _vm.dialogUploadLiveClass = $$v
      },
      expression: "dialogUploadLiveClass"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "font-weight-500"
  }, [_vm._v("Upload Live Class")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeDialog()
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "800px"
    }
  }, [
    [_c('transition', {
      attrs: {
        "name": "carousel"
      }
    }, [(_vm.page_upload === 'list') ? _c('div', [_c('div', {
      staticClass: "px-2 pt-10 pb-7"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "9"
      }
    }, [_c('v-text-field', {
      attrs: {
        "append-icon": "mdi-magnify",
        "placeholder": "Cari Gambar",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: (_vm.search),
        callback: function($$v) {
          _vm.search = $$v
        },
        expression: "search"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "d-flex align-center",
      staticStyle: {
        "gap": "15px"
      },
      attrs: {
        "cols": "3"
      }
    }, [_c('v-btn-toggle', {
      attrs: {
        "mandatory": ""
      },
      model: {
        value: (_vm.toggle_exclusive),
        callback: function($$v) {
          _vm.toggle_exclusive = $$v
        },
        expression: "toggle_exclusive"
      }
    }, [_c('v-btn', {
      on: {
        "click": function($event) {
          _vm.mode_view = 'image'
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-image-outline")])], 1), _vm._v(" "), _c('v-btn', {
      on: {
        "click": function($event) {
          _vm.mode_view = 'list'
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-view-list-outline")])], 1)], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "success",
        "depressed": "",
        "dark": "",
        "large": ""
      },
      on: {
        "click": function($event) {
          _vm.page_upload = 'add'
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-plus")]), _vm._v("\n                                        Upload\n                                    ")], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "px-2",
      attrs: {
        "hidden": _vm.mode_view === 'image'
      }
    }, [
      [_c('v-data-table', {
        attrs: {
          "headers": _vm.headers,
          "items": _vm.thumbnails,
          "search": _vm.search,
          "loading": _vm.isLoadingImage,
          "loading-text": "Mengambil data gambar..",
          "no-data-text": "Gambar tidak tersedia",
          "no-results-text": "Gambar tidak ditemukan",
          "footer-props": {
            'items-per-page-options': [10, 25],
          }
        },
        scopedSlots: _vm._u([{
          key: "item.action",
          fn: function(ref) {
            var item = ref.item;

            return [_c('v-btn', {
              staticClass: "white--text",
              attrs: {
                "depressed": "",
                "small": "",
                "color": "blew"
              },
              on: {
                "click": function($event) {
                  return _vm.$emit('selected', item.url)
                }
              }
            }, [_vm._v("\n                                            Pilih\n                                        ")]), _vm._v(" "), _c('v-btn', {
              staticClass: "white--text ml-1",
              attrs: {
                "depressed": "",
                "small": "",
                "color": "primary"
              },
              on: {
                "click": function($event) {
                  return _vm.openUrl(item.url)
                }
              }
            }, [_vm._v("\n                                            Buka\n                                        ")])]
          }
        }], null, false, 3169415272)
      })]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "mt-7",
      attrs: {
        "hidden": _vm.mode_view === 'list'
      }
    }, [(_vm.isLoadingImage) ? _c('div', {
      staticClass: "mt-10",
      attrs: {
        "align": "center"
      }
    }, [_c('v-progress-circular', {
      attrs: {
        "width": 4,
        "size": 35,
        "color": "blew",
        "indeterminate": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
      staticClass: "px-1"
    }, [_vm._l((_vm.img_upload), function(file, index) {
      return _c('v-col', {
        key: index,
        staticClass: "pb-8",
        attrs: {
          "sm": "3",
          "cols": "3"
        }
      }, [_c('v-card', {
        staticClass: "mx-auto mb-6 fullheight",
        attrs: {
          "outlined": "",
          "max-width": "400"
        }
      }, [_c('v-img', {
        staticClass: "img-fluid",
        attrs: {
          "src": file.url,
          "title": 'file' + index,
          "height": "150px"
        }
      }), _vm._v(" "), _c('v-card-text', [_c('div', {
        staticClass: "font-weight-bold pb-3"
      }, [_vm._v("\n                                                " + _vm._s(file.name) + "\n                                            ")])]), _vm._v(" "), _c('v-card-actions', {
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "width": "100%"
        }
      }, [_c('v-btn', {
        staticClass: "white--text",
        attrs: {
          "depressed": "",
          "small": "",
          "block": "",
          "color": "blew"
        },
        on: {
          "click": function($event) {
            return _vm.$emit(
              'selected',
              file.url
            )
          }
        }
      }, [_vm._v("\n                                                Pilih Gambar\n                                            ")])], 1)], 1)], 1)
    }), _vm._v(" "), (
      !_vm.isLoadingImage &&
      !_vm.img_upload.length
    ) ? _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "text-center mt-10"
    }, [_vm._v("\n                                        Gambar tidak ditemukan..\n                                    ")])]) : _vm._e()], 2)], 1)]) : _vm._e()])], _vm._v(" "), [_c('transition', {
      attrs: {
        "name": "carousel"
      }
    }, [(_vm.page_upload === 'add') ? _c('div', [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "px-2"
    }, [_c('div', {
      staticClass: "mt-5 mb-4"
    }, [_c('v-btn', {
      attrs: {
        "color": "#ec675e",
        "depressed": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          ((_vm.page_upload = 'list'),
            _vm.getImageUpload())
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-arrow-left")]), _vm._v("\n                                        Kembali\n                                    ")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "font-weight-bold pb-2 mt-5 mb-1 d-flex align-center",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v("\n                                    " + _vm._s(!_vm.file_images.length ?
      "Pilih Gambar *" :
      "List Gambar") + "\n\n                                    "), (!_vm.file_images.length) ? _c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "nudge-bottom": 10,
        "offset-y": "500"
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;
          var attrs = ref.attrs;

          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "ml-1",
            attrs: {
              "color": "#474958",
              "dark": "",
              "icon": "",
              "small": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi\n                                                    mdi-information")])], 1)]
        }
      }], null, false, 2919581230),
      model: {
        value: (_vm.menu),
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    }, [_vm._v(" "), _c('v-card', {
      attrs: {
        "rounded": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-3"
    }, [_c('div', {
      staticClass: "font-weight-600 mb-2"
    }, [_vm._v("\n                                                    Petunjuk\n                                                ")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n                                                        Maksimum ukuran file\n                                                        300 KB\n                                                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                                                        File gambar yang\n                                                        diizinkan : png,\n                                                        jpg, jpeg\n                                                    ")])])])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "10"
      }
    }, [(!_vm.file_images.length) ? _c('div', {
      staticClass: "wrapper-custom-input mt-2"
    }, [_c('v-card', {
      staticStyle: {
        "border": "2px #bdbdbd"
      },
      attrs: {
        "outlined": "",
        "color": "#f7f8fa"
      }
    }, [_c('v-card-text', {
      staticClass: "py-6"
    }, [_c('div', {
      staticClass: "d-flex align-center",
      staticStyle: {
        "gap": "10px",
        "justify-content": "center"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#999999",
        "large": ""
      }
    }, [_vm._v("\n                                                            mdi\n                                                            mdi-cloud-upload\n                                                        ")]), _vm._v(" "), _c('span', {
      staticClass: "ml-3"
    }, [_c('p', [_vm._v("\n                                                                Tarik dan\n                                                                letakkan\n                                                                atau\n                                                                "), _c('b', {
      staticClass: "text-primary"
    }, [_vm._v("Pilih\n                                                                    Gambar")]), _vm._v("\n                                                                untuk unggah\n                                                                gambar live\n                                                                class\n                                                            ")]), _vm._v(" "), _c('p', [_vm._v("\n                                                                Pastikan\n                                                                sesuai\n                                                                format png,\n                                                                jpg, jpeg\n                                                                yang\n                                                                disediakan\n                                                                dengan\n                                                                maksimal\n                                                                ukuran\n                                                                300kb.\n                                                            ")])])], 1)])], 1), _vm._v(" "), _c('input', {
      staticClass: "custom-file-input",
      attrs: {
        "type": "file",
        "multiple": "",
        "accept": "image/svg, image/jpg, image/png, image/jpeg"
      },
      on: {
        "change": _vm.addFilesImages
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.file_images.length) ? _c('div', [_c('div', {
      staticClass: "content-display pt-5"
    }, [_c('v-row', {
      staticClass: "px-1"
    }, _vm._l((_vm.file_images), function(file, f) {
      return _c('v-col', {
        key: f,
        attrs: {
          "sm": "4",
          "cols": "4"
        }
      }, [_c('v-card', {
        staticClass: "mx-auto mb-6",
        attrs: {
          "max-width": "400",
          "outlined": ""
        }
      }, [_c('v-img', {
        staticClass: "img-fluid",
        attrs: {
          "src": _vm.imageSources[
            f
          ],
          "title": file.name,
          "height": "150px"
        }
      }), _vm._v(" "), _c('v-card-text', {
        staticClass: "text--primary px-3"
      }, [_c('div', {
        staticStyle: {
          "min-height": "50px"
        }
      }, [_vm._v("\n                                                                    " + _vm._s(file.name) + "\n                                                                    "), _c('v-btn', {
        staticClass: "ml-1",
        attrs: {
          "rounded": "",
          "depressed": "",
          "small": ""
        }
      }, [_vm._v("\n                                                                        " + _vm._s((
        file.size /
        1000
      ).toFixed(
        1
      )) + "\n                                                                        KB\n                                                                    ")])], 1), _vm._v(" "), _c('v-btn', {
        staticClass: "mt-5",
        attrs: {
          "outlined": "",
          "color": "red",
          "block": ""
        },
        on: {
          "click": function($event) {
            return _vm.removeImage(
              f
            )
          }
        }
      }, [_c('v-icon', {
        staticClass: "mr-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                                                        mdi-delete\n                                                                    ")]), _vm._v("\n                                                                    Hapus\n                                                                ")], 1)], 1)], 1)], 1)
    }), 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "md": "2"
      }
    }, [_c('v-btn', {
      staticClass: "white--text mt-2",
      attrs: {
        "depressed": "",
        "large": "",
        "block": "",
        "color": "#27ae60",
        "disabled": !_vm.file_images.length,
        "loading": _vm.isLoading
      },
      on: {
        "click": function($event) {
          return _vm.uploadImage()
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v("mdi-plus")]), _vm._v("\n                                            Upload\n                                        ")], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])]
  ], 2)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "top": "",
      "color": "blew",
      "timeout": "1500"
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', attrs, false), [_vm._v("\n                Tutup\n            ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.snackbar_text) + "\n\n        ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-412e2e49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/UploadImage.vue
// module id = 1700
// module chunks = 1